import { cloneDeep, cloneDeepWith } from "lodash";
import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../mdae-framework";
import { GET_EM_CATEGORY_LIST } from "../services/get-em-category-list";
import { GET_EM_DOS_LIST } from "../services/get-em-dos-list";
import { addMonths } from "date-fns";
import { GET_EM_UTILIZATION_LIST } from "../services/get-em-utilization-list";

export const TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP =
  "TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP";
export const SET_EM_PROVIDER_LIST = "SET_EM_PROVIDER_LIST";
export const SET_EM_DOS_LIST = "SET_EM_DOS_LIST";
export const SET_WIDGET_INSTANCE = "SET_WIDGET_INSTANCE";
export const SET_BELL_CURVE_REPORT_PARAMETER_VALUES =
  "SET_BELL_CURVE_REPORT_PARAMETER_VALUES";
export const SET_GRID_HEADER_VALUES = "SET_GRID_HEADER_VALUES";
export const TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP = "TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP";
export const SET_SHOW_HIDE_DATA = "SET_SHOW_HIDE_DATA";
const mainGridDataSource = [
  {
    fieldName: "DOS Range:",
    selectedValue: "",
  },
  {
    fieldName: "E&M Categories:",
    selectedValue: "",
  },
  {
    fieldName: "Define Target:",
    selectedValue: "",
  },
  {
    fieldName: "Additional Report Options:",
    selectedValue: "",
  },
  {
    fieldName: "Export format:",
    selectedValue: "",
  },
];
const targetRadioGroupOptions = [
  { text: "Single Provider", value: "Provider" },
  { text: "Rendering Provider Group - All Providers", value: "Provider Group" },
];
const formatRadioGroupOptions = [
  { text: "PDF", value: "pdf" },
  { text: "Word (.docx)", value: "docx" },
];
const addReportParameterList = [
  {
    reportParm: "Low Volume Providers (i)",
    reportParmKey: "LOW_VOLUME_PROVIDERS",
    id: 1,
  },
  {
    reportParm: "MDaudit Normative Series",
    reportParmKey: "MDAUDIT_NORMATIVE_SERIES",
    id: 2,
  },
  {
    reportParm: "Provider Classification Series",
    reportParmKey: "PROVIDER_CLASSIFICAION_SERIES",
    id: 3,
  },
  {
    reportParm: "Provider Specialization Series",
    reportParmKey: "PROVIDER_SPECIALIZATION_SERIES",
    id: 4,
  },
  {
    reportParm: "CMS National Normative Series",
    reportParmKey: "CMS_NATIONAL_NORMATIVE_SERIES",
    id: 5,
  },
  {
    reportParm: "Rendering Provider Group Series",
    reportParmKey: "RENDERING_PROVIDER_GROUP_SERIES",
    id: 6,
  }
];

const widgetInstances = {
  mainDataGrid: null,
  normativeDataSourceList: null,
  isProviderGroupSeriesCheckbox: null,
  isProviderClassificationSeriesCheckbox: null,
  isProviderSpecializationSeriesCheckbox: null,
  isNormativeSeriesCheckbox: null,
  dosTreeView: null,
  categoryList: null,
  targetProviderSelectBox: null,
  targetProviderGroupSelectBox: null,
  targetRadioButton: null,
  loadPanel: null,
  isIncludeLowVolumeProvidersCheckbox: null,
  formatRadioButton: null,
};
const bellCurveReportParameterSeriesValues = {
  providerGroup: [],
  providerClassification: [],
  providerSpecialization: [],
};
var bellCurveReportParameterValues = {
  dosList: [],
  categoryList: [],
  selectedTargetType: "",
  selectedTargetProviderValue: null,
  selectedTargetProviderGroupValue: null,
  isIncludeLowVolumeProviders: false,
  isNormativeSeriesSelected: false,
  normativeSeriesValues: [],
  normativeSelectedSeriesValues: [],
  isProviderGroupSeriesSelected: false,
  providerGroupSeriesValues: [],
  isProviderClassificationSeriesSelected: false,
  providerClassificationSeriesSelectedValues: [],
  isProviderSpecializationSeriesSelected: false,
  providerSpecializationSeriesSelectedValues: [],
  exportFormatForLongRunningReports: "pdf"

};
const bellCurveReportParameterSeriesCheckboxText = {
  bellCurveReportParameterIsProviderClassificationSeriesCheckboxText:
    "Provider Classification",
  bellCurveReportParameterIsProviderSpecializationSeriesCheckboxText:
    "Provider Specialization",
  bellCurveReportParameterIsProviderGroupSeriesCheckboxText:
    "Rendering Provider Group",
  bellCurveReportParameterIsNormativeSeriesCheckboxText: "Normative",
};
export const bellCurveReportParameterKey = {
  bellCurveReportParameterEMCategoryKey:
    "EM_CATEGORY_KEY",
  bellCurveReportParameterAdditionalReportOptionKey:
    "ADDITIONAL_REPORT_OPTION_KEY"
};
const bellCurveReportParameterSeriesCheckboxDisabled = {
  bellCurveReportParameterIsProviderClassificationSeriesCheckboxDisable: true,
  bellCurveReportParameterIsProviderSpecializationSeriesCheckboxDisable: true,
  bellCurveReportParameterIsProviderGroupSeriesCheckboxDisable: true,
  bellCurveReportParameterIsNormativeSeriesCheckboxDisable: true,
  bellCurveReportParameterNormativeListDisable: true,
};
const initialState = {
  isDataSourceLoaded: false,
  bellCurveReportParameterEmDOSList: [],
  bellCurveReportParameterEmCategoryList: [],
  mainGrid: mainGridDataSource,
  bellCurveReportOneYearMonthList: [],
  targetRadioGroupOptions: targetRadioGroupOptions,
  formatRadioGroupOptions: formatRadioGroupOptions,
  bellCurveReportParameterEmDOSSelectedItems: [],
  normativeDataSourceList: [],
  providerList: [],
  providerGroupList: [],
  bellCurveReportParameterWidgetInstances: widgetInstances,
  bellCurveReportParameterSeriesValues: bellCurveReportParameterSeriesValues,
  bellCurveReportParameterValues: bellCurveReportParameterValues,
  bellCurveReportParameterSeriesCheckboxText: bellCurveReportParameterSeriesCheckboxText,
  bellCurveReportParameterSeriesCheckboxDisabled: bellCurveReportParameterSeriesCheckboxDisabled,
  normativeSelectedItem: [],
  rowIndex: 0,
  defaultCategory: {},
  bellCurveReportParameterKey: bellCurveReportParameterKey,
  showHideLHSData: [],
  showHideRHSData: [],
  addReportParameterList: addReportParameterList
};

export default function (state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_BELL_CURVE_REPORT_PARAMETER_POPUP:
    case TOGGLE_BELL_CURVE_REPORT_WARNING_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_EM_PROVIDER_LIST:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          providerList: action.data.response.providerList,
          providerGroupList: action.data.response.providerGroupList,
          isDataSourceLoaded: action.data.isDataSourceLoaded,
        };
      }
      return newState;
    case SET_SHOW_HIDE_DATA:
      newState = { ...state };
      if (action.data.widgetKey == bellCurveReportParameterKey.bellCurveReportParameterEMCategoryKey) {
        newState.bellCurveReportParameterValues.categoryList = action.data.showItems
        newState = {
          ...newState,
          [bellCurveReportParameterKey.bellCurveReportParameterEMCategoryKey + "showHideLHSData"]: action.data.hideItems,
          [bellCurveReportParameterKey.bellCurveReportParameterEMCategoryKey + "showHideRHSData"]: action.data.showItems
        };
      }
      else if (action.data.widgetKey == bellCurveReportParameterKey.bellCurveReportParameterAdditionalReportOptionKey) {
        action.data.showItems?.forEach((e) => {
          if (e.reportParmKey == 'MDAUDIT_NORMATIVE_SERIES' || e.reportParmKey == 'CMS_NATIONAL_NORMATIVE_SERIES') {
            newState.bellCurveReportParameterValues.isNormativeSeriesSelected = true;
            let normativeSelectedSeriesValues = [];
            state.normativeDataSourceList.forEach((item) => {
              if ((item.key == "CMS_NATIONAL" && e.reportParmKey == 'CMS_NATIONAL_NORMATIVE_SERIES') ||
                (item.key == "MDAE_NATIONAL" && e.reportParmKey == 'MDAUDIT_NORMATIVE_SERIES')) {
                normativeSelectedSeriesValues.push(item);
              }
            })
            newState.bellCurveReportParameterValues.normativeSelectedSeriesValues = normativeSelectedSeriesValues;
          }
          if (e.reportParmKey == 'RENDERING_PROVIDER_GROUP_SERIES') {
            newState.bellCurveReportParameterValues.isProviderGroupSeriesSelected = true;
          }
          if (e.reportParmKey == 'PROVIDER_CLASSIFICAION_SERIES') {
            newState.bellCurveReportParameterValues.isProviderClassificationSeriesSelected = true;
          }
          if (e.reportParmKey == 'PROVIDER_SPECIALIZATION_SERIES') {
            newState.bellCurveReportParameterValues.isProviderSpecializationSeriesSelected = true;
          }
        });
        newState = {
          ...newState,
          [bellCurveReportParameterKey.bellCurveReportParameterAdditionalReportOptionKey + "showHideLHSData"]: action.data.hideItems,
          [bellCurveReportParameterKey.bellCurveReportParameterAdditionalReportOptionKey + "showHideRHSData"]: action.data.showItems
        };
        let reportParameterAdditionalReportOptionsCookie = {
          showItems: action.data.showItems,
          hideItems: action.data.hideItems
        }
        localStorage.setItem("ReportParameter_Additional_Report_Options_Cookie", JSON.stringify(reportParameterAdditionalReportOptionsCookie));
      }
      setGridHeaderValues(action.data.rowIndex, newState);
      return newState;
    case SET_WIDGET_INSTANCE:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const bellCurveReportParameterWidgetInstances = newState.bellCurveReportParameterWidgetInstances
          ? newState.bellCurveReportParameterWidgetInstances
          : {};
        for (let prop in action.data.bellCurveReportParameterWidgetInstances) {
          bellCurveReportParameterWidgetInstances[prop] =
            action.data.bellCurveReportParameterWidgetInstances[prop];
        }
        newState = {
          ...newState,
          bellCurveReportParameterWidgetInstances: bellCurveReportParameterWidgetInstances,
        };
      }
      return newState;
    case SET_BELL_CURVE_REPORT_PARAMETER_VALUES:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      if (action.data.bellCurveReportParameterValues)
        newState.bellCurveReportParameterValues = {
          ...action.data.bellCurveReportParameterValues,
        };

      newState = { ...newState };
      return newState;
    case SET_GRID_HEADER_VALUES:
      newState = cloneDeepWith(state);
      var rowIndex = action.data.rowIndex;
      if (action.data.bellCurveReportParameterEmDOSSelectedItems)
        newState.bellCurveReportParameterEmDOSSelectedItems =
          action.data.bellCurveReportParameterEmDOSSelectedItems;
      if (action.data.bellCurveReportParameterEmDOSList)
        newState.bellCurveReportParameterEmDOSList =
          action.data.bellCurveReportParameterEmDOSList;
      if (
        action.data.isNormativeSeriesSelected == false ||
        action.data.isNormativeSeriesSelected == true
      )
        newState.bellCurveReportParameterValues.isNormativeSeriesSelected =
          action.data.isNormativeSeriesSelected;
      if (
        action.data.isProviderGroupSeriesSelected == false ||
        action.data.isProviderGroupSeriesSelected == true
      )
        newState.bellCurveReportParameterValues.isProviderGroupSeriesSelected =
          action.data.isProviderGroupSeriesSelected;
      if (
        action.data.isProviderClassificationSeriesSelected == false ||
        action.data.isProviderClassificationSeriesSelected == true
      )
        newState.bellCurveReportParameterValues.isProviderClassificationSeriesSelected =
          action.data.isProviderClassificationSeriesSelected;
      if (
        action.data.isProviderSpecializationSeriesSelected == false ||
        action.data.isProviderSpecializationSeriesSelected == true
      )
        newState.bellCurveReportParameterValues.isProviderSpecializationSeriesSelected =
          action.data.isProviderSpecializationSeriesSelected;
      if (action.data.selectedTargetType)
        newState.bellCurveReportParameterValues.selectedTargetType =
          action.data.selectedTargetType;
      if (action.data.selectedTargetProviderValue)
        newState.bellCurveReportParameterValues.selectedTargetProviderValue =
          action.data.selectedTargetProviderValue;
      if (action.data.selectedTargetProviderGroupValue)
        newState.bellCurveReportParameterValues.selectedTargetProviderGroupValue =
          action.data.selectedTargetProviderGroupValue;
      setGridHeaderValues(rowIndex, newState);
      return (newState = { ...newState });
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_EM_CATEGORY_LIST)(action)) {
        return { ...state, bellCurveReportParameterEmCategoryList: [] };
      }
      if (isAsyncComplete(GET_EM_CATEGORY_LIST)(action)) {
        const data = action.response;
        var template = function (item) {
          return (
            '<div style="margin-left:5px;margin-top:5px;">' +
            item.text +
            "</div>"
          );
        };
        for (let i = 0; i < data.length; i++) {
          data[i].text = data[i].emCategory;
          data[i].id = data[i].emCategoryId;
          data[i].template = template;
        }
        data.sort(function (a, b) {
          if (a.emCategory < b.emCategory) {
            return -1;
          }
          if (a.emCategory > b.emCategory) {
            return 1;
          }
          return 0;
        });
        const defaultCategory = {

        };
        return {
          ...state,
          bellCurveReportParameterEmCategoryList: data,
          bellCurveReportParameterValues: bellCurveReportParameterValues,
          defaultCategory: defaultCategory,
        };
      }
      if (isAsyncOperation(GET_EM_DOS_LIST)(action)) {
        return { ...state, bellCurveReportParameterEmDOSList: [] };
      }
      if (isAsyncComplete(GET_EM_DOS_LIST)(action)) {
        const dos = action.response;
        var bellCurveReportOneYearMonthList = [];
        var returnArray = [];
        var returnObj = {};
        var onYearBackDate = new Date(
          addMonths(new Date(), -12).toDateString()
        );
        var template = function (item) {
          return (
            '<div style="margin-left:5px;font-size: 12px">' +
            item.text +
            "</div>"
          );
        };
        for (let i = 0; i < dos.length; i++) {
          var q = dos[i].dosQuarter;
          var m = dos[i].dosMonth;
          if (returnObj[dos[i].dosYear]) {
            if (returnObj[dos[i].dosYear][q]) {
              returnObj[dos[i].dosYear][q][m] = true;
            } else {
              returnObj[dos[i].dosYear][q] = {};
              returnObj[dos[i].dosYear][q][m] = true;
            }
          } else {
            returnObj[dos[i].dosYear] = {};
            returnObj[dos[i].dosYear][q] = {};
            returnObj[dos[i].dosYear][q][m] = true;
          }
        }
        for (var year in returnObj) {
          var y = {
            id: year,
            text: year,
            items: [],
            type: "year",
            template: template,
          };
          for (var quarter in returnObj[year]) {
            var q: any = {
              id: quarter,
              text: quarter,
              items: [],
              type: "quarter",
              template: template,
            };
            for (var month in returnObj[year][quarter]) {
              var m: any = {
                id: month,
                text: month,
                items: [],
                type: "month",
                template: template,
              };
              q.items.push(m);

              if (onYearBackDate <= new Date(month)) {
                bellCurveReportOneYearMonthList.push(month);
              }
            }
            y.items.push(q);
          }
          returnArray.push(y);
        }
        return {
          ...state,
          bellCurveReportParameterEmDOSList: returnArray,
          bellCurveReportOneYearMonthList: bellCurveReportOneYearMonthList,
        };
      }
      if (isAsyncOperation(GET_EM_UTILIZATION_LIST)(action)) {
        return { ...state, normativeDataSourceList: [] };
      }
      if (isAsyncComplete(GET_EM_UTILIZATION_LIST)(action)) {
        for (let i = 0; i < action.response.length; i++) {
          action.response[i].dataSourceName = action.response[
            i
          ].dataSourceName.replace(",", "");
          action.response[i].text = action.response[i].dataSourceName;
          action.response[i].key = action.response[i].dataSource;
        }
        return { ...state, normativeDataSourceList: action.response };
      }
      return state;
    default:
      return state;
  }
}

function formatBellCurveReportParameterDosDate(dosDate) {
  if (dosDate) {
    dosDate = new Date(dosDate);
    var month = dosDate.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    var year = dosDate.getFullYear();
    var date = dosDate.getDate();
    date = date < 10 ? "0" + date : date;
    return month + "/" + date + "/" + year;
  }
}

function getAddSeriesHeaderColumnText(normativeSelectedItem, newState) {
  var text = "";
  var stringJoin = function (dataArray, joinChar, prop) {
    var outputStr = "";
    if (dataArray && joinChar) {
      for (let i = 0; i < dataArray.length; i++) {
        if (prop) {
          outputStr = outputStr + dataArray[i][prop] + joinChar;
        } else {
          outputStr = outputStr + dataArray[i] + joinChar;
        }
      }
      outputStr = outputStr.slice(0, outputStr.length - joinChar.length);
    }
    return outputStr;
  };
  var selectedNormativeDataSourceItems = normativeSelectedItem;
  if (
    newState.bellCurveReportParameterValues.isProviderGroupSeriesSelected &&
    newState.bellCurveReportParameterSeriesValues.providerGroup &&
    newState.bellCurveReportParameterSeriesValues.providerGroup.length
  ) {
    text =
      stringJoin(
        newState.bellCurveReportParameterSeriesValues.providerGroup,
        ",",
        ""
      ) + ", ";
  }
  if (
    newState.bellCurveReportParameterValues.isNormativeSeriesSelected &&
    selectedNormativeDataSourceItems &&
    selectedNormativeDataSourceItems.length
  ) {
    text =
      text +
      stringJoin(selectedNormativeDataSourceItems, ", ", "dataSourceName") +
      ", ";
  }
  if (
    newState.bellCurveReportParameterValues.selectedTargetType == "Provider"
  ) {
    if (
      newState.bellCurveReportParameterValues
        .isProviderClassificationSeriesSelected &&
      newState.bellCurveReportParameterSeriesValues.providerClassification &&
      newState.bellCurveReportParameterSeriesValues.providerClassification
        .length
    ) {
      text =
        text +
        stringJoin(
          newState.bellCurveReportParameterSeriesValues.providerClassification,
          ",",
          ""
        ) +
        ", ";
    }

    if (
      newState.bellCurveReportParameterValues
        .isProviderSpecializationSeriesSelected &&
      newState.bellCurveReportParameterSeriesValues.providerSpecialization &&
      newState.bellCurveReportParameterSeriesValues.providerSpecialization
        .length
    ) {
      text =
        text +
        stringJoin(
          newState.bellCurveReportParameterSeriesValues.providerSpecialization,
          ",",
          ""
        ) +
        ", ";
    }
  } else if (
    newState.bellCurveReportParameterValues.selectedTargetType ==
    "Provider Group"
  ) {
    if (
      newState.bellCurveReportParameterValues
        .isProviderClassificationSeriesSelected &&
      newState.bellCurveReportParameterSeriesValues.providerClassification &&
      newState.bellCurveReportParameterSeriesValues.providerClassification
        .length > 1
    ) {
      text = text + "Class: Multi, ";
    } else if (
      newState.bellCurveReportParameterValues
        .isProviderClassificationSeriesSelected &&
      newState.bellCurveReportParameterSeriesValues.providerClassification &&
      newState.bellCurveReportParameterSeriesValues.providerClassification
        .length
    ) {
      text =
        text +
        stringJoin(
          newState.bellCurveReportParameterSeriesValues.providerClassification,
          ",",
          ""
        ) +
        ", ";
    }

    if (
      newState.bellCurveReportParameterValues
        .isProviderSpecializationSeriesSelected &&
      newState.bellCurveReportParameterSeriesValues.providerSpecialization &&
      newState.bellCurveReportParameterSeriesValues.providerSpecialization
        .length > 1
    ) {
      text = text + "Spec: Multi, ";
    } else if (
      newState.bellCurveReportParameterValues
        .isProviderSpecializationSeriesSelected &&
      newState.bellCurveReportParameterSeriesValues.providerSpecialization &&
      newState.bellCurveReportParameterSeriesValues.providerSpecialization
        .length
    ) {
      text =
        text +
        stringJoin(
          newState.bellCurveReportParameterSeriesValues.providerSpecialization,
          ",",
          ""
        ) +
        ", ";
    }
  }
  text = text.slice(0, text.length - 2);
  return text;
}

function setGridHeaderValues(rowIndex, newState) {
  if (rowIndex == 0) {
    if (
      newState.bellCurveReportParameterEmDOSSelectedItems &&
      newState.bellCurveReportParameterEmDOSSelectedItems.length
    ) {
      var dosValue =
        formatBellCurveReportParameterDosDate(
          newState.bellCurveReportParameterEmDOSSelectedItems[0].id
        ) +
        " - " +
        formatBellCurveReportParameterDosDate(
          newState.bellCurveReportParameterEmDOSSelectedItems[
            newState.bellCurveReportParameterEmDOSSelectedItems.length - 1
          ].id
        );
      newState.mainGrid[0].selectedValue = dosValue;
    } else {
      newState.mainGrid[0].selectedValue = "";
    }
    var tempObj = JSON.parse(JSON.stringify(newState.mainGrid[0]));
    newState.mainGrid[0] = tempObj;
  } else if (rowIndex == 1) {
    var selectedCategoryItemList =
      newState.bellCurveReportParameterValues.categoryList;
    newState.mainGrid[1].selectedValue = "";
    var tempObj = JSON.parse(JSON.stringify(newState.mainGrid[1]));
    newState.mainGrid[1] = tempObj;
  } else if (rowIndex == 2) {
    var selectedTargetType =
      newState.bellCurveReportParameterValues.selectedTargetType;
    if (
      selectedTargetType == "Provider" &&
      newState.bellCurveReportParameterValues.selectedTargetProviderValue
    ) {
      var selectedTargetProviderValue =
        newState.bellCurveReportParameterValues.selectedTargetProviderValue;
      newState.mainGrid[2].selectedValue =
        selectedTargetProviderValue.providerName;
    } else if (
      selectedTargetType == "Provider Group" &&
      newState.bellCurveReportParameterValues.selectedTargetProviderGroupValue
    ) {
      newState.mainGrid[2].selectedValue = newState
        .bellCurveReportParameterValues.selectedTargetProviderGroupValue
        .providerGroupName
        ? newState.bellCurveReportParameterValues
          .selectedTargetProviderGroupValue.providerGroupName +
        " - All Providers"
        : "";
    } else {
      newState.mainGrid[2].selectedValue = "";
    }
    var tempObj = JSON.parse(JSON.stringify(newState.mainGrid[2]));
    newState.mainGrid[2] = tempObj;
  } else if (rowIndex == 3) {
    newState.mainGrid[3].selectedValue = "";
    var tempObj = JSON.parse(JSON.stringify(newState.mainGrid[3]));
    newState.mainGrid[3] = tempObj;
  }
}
